import React, { Suspense } from 'react';
import { Route } from 'react-router-dom';
import Fallback from './Elements/Fallback'

import AppAppBar from './modules/views/AppAppBar';
import AppFooter from './modules/views/AppFooter';
import { Outlet, HashRouter } from 'react-router-dom';

const Home = React.lazy(() => import('./modules/Pages/Home'));
const Terms = React.lazy(() => import('./modules/Pages/Terms'));
const BookOnline = React.lazy(() => import('./modules/Pages/BookOnline'));


const ZZZSuspense = ({ children }) => {
    return <Suspense fallback={<Fallback />}>{children}</Suspense>
}
function HomeLayout() {
    return (
        <React.Fragment>
            <AppAppBar />
            <Outlet />
            <AppFooter />
        </React.Fragment>
    );
}

const Routes = (
    <>
        <Route path="/" element={<ZZZSuspense><HomeLayout /></ZZZSuspense>} 
        // errorElement={<ErrorBoundary />}
        errorElement={<>Page not found</>}
        >
            <Route index element={<ZZZSuspense><Home /></ZZZSuspense>} />
            <Route path="/terms-and-conditions" element={<ZZZSuspense><Terms /></ZZZSuspense>} />
            <Route path="/book-online" element={<ZZZSuspense><BookOnline /></ZZZSuspense>} />
           
        </Route>
    
    </>
);

export default Routes;